import type { ConflitoPassosProps } from "./types-conflito-passos";
import { ConflitoPassosView } from "./view-conflito-passos";

/** Passos "Selecionar" e "Revisão" do remanejamento, iguais nos três fluxos de conflito. */
export function ConflitoPassos(props: ConflitoPassosProps) {
  return <ConflitoPassosView {...props} />;
}

export type * from "./types-conflito-passos";
